<template>
	<div>
		<acessar-minhas-adesoes-listagem
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:paginacao="paginacao"
			:itens="datasource"
			@paginar="paginarListagem"
			@resetar-page="resetarPaginacao"
			@recarregar-listagem-externa="buscarListagem"
		>
		</acessar-minhas-adesoes-listagem>
	</div>
</template>
<script>
import AcessarMinhasAdesoesListagem from '@/views/pages/ata/acessar/gestao-da-ata/minhas-adesoes/listagem/AcessarMinhasAdesoesListagem.vue'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import { actionTypes } from '@/core/constants'
import adesaoAta from '@/views/mixins/adesaoAta'
export default {
	name: 'acessar-minhas-adesoes-view',
	components: { AcessarMinhasAdesoesListagem },
	mixins: [adesaoAta],
	data() {
		return {
			totalPaginas: 0,
			totalItens: 0,
			paginacao: this.$store.state.adesao.paginacao,
			datasource: [],
		}
	},
	async created() {
		await this.buscarListagem()
	},
	methods: {
		async buscarListagem() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ADESAO.BUSCAR_LISTAGEM,
				this.getParamsListagem(),
			)

			this.datasource = itens
			this.totalItens = totalElements
			this.totalPaginas = totalPages
		},
		async paginarListagem(paginacao) {
			this.paginacao = paginacao
			await this.buscarListagem()
		},
		resetarPaginacao() {
			this.paginacao.page = 1
		},
	},
}
</script>
